module.exports = __webpack_public_path__ + "static/media/bur2.d4658f14.jpeg";